import api from './api';

export const uploadFileOnBase = (data) => {
    return api.post( `${process.env.REACT_APP_INSTANCE}${process.env.REACT_APP_ENVIROMENT}onboardingservices/enviararchivo`, data);
}

export const completeTask = (payload) => {
    return api.post(`${process.env.REACT_APP_INSTANCE}${process.env.REACT_APP_ENVIROMENT}ms-workflow-mediator/generic/process/task/complete`, payload);
}

export const getIdProcess = (idCredit) => {
    return api.get(`${process.env.REACT_APP_INSTANCE}${process.env.REACT_APP_ENVIROMENT}ms-workflow-mediator/generic/process/idCredit/${idCredit}`);
}
